/**
 * @generated SignedSource<<61d77e6dc612f999abcc52eba863c454>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AutomatedTradingPromoQuery$variables = {
  minInvestmentAgeDays: number;
  minValueUsd: bigint;
};
export type AutomatedTradingPromoQuery$data = {
  readonly finV3: {
    readonly ranges: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly analytics: {
            readonly apr: bigint;
          } | null | undefined;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
  };
};
export type AutomatedTradingPromoQuery = {
  response: AutomatedTradingPromoQuery$data;
  variables: AutomatedTradingPromoQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "minInvestmentAgeDays"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "minValueUsd"
  }
],
v1 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1
  },
  {
    "kind": "Variable",
    "name": "minInvestmentAgeDays",
    "variableName": "minInvestmentAgeDays"
  },
  {
    "kind": "Variable",
    "name": "minValueUsd",
    "variableName": "minValueUsd"
  },
  {
    "kind": "Literal",
    "name": "sortBy",
    "value": "APR"
  },
  {
    "kind": "Literal",
    "name": "sortDir",
    "value": "DESC"
  },
  {
    "kind": "Literal",
    "name": "status",
    "value": "OPEN"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "apr",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AutomatedTradingPromoQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "FinV3",
        "kind": "LinkedField",
        "name": "finV3",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "FinRangeConnection",
            "kind": "LinkedField",
            "name": "ranges",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "FinRangeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FinRange",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FinRangePositionAnalytics",
                        "kind": "LinkedField",
                        "name": "analytics",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AutomatedTradingPromoQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "FinV3",
        "kind": "LinkedField",
        "name": "finV3",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "FinRangeConnection",
            "kind": "LinkedField",
            "name": "ranges",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "FinRangeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FinRange",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FinRangePositionAnalytics",
                        "kind": "LinkedField",
                        "name": "analytics",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ea2a306e41d71cc4e579f800b9427511",
    "id": null,
    "metadata": {},
    "name": "AutomatedTradingPromoQuery",
    "operationKind": "query",
    "text": "query AutomatedTradingPromoQuery(\n  $minInvestmentAgeDays: Int!\n  $minValueUsd: Bigint!\n) {\n  finV3 {\n    ranges(first: 1, status: OPEN, sortBy: APR, sortDir: DESC, minInvestmentAgeDays: $minInvestmentAgeDays, minValueUsd: $minValueUsd) {\n      edges {\n        node {\n          analytics {\n            apr\n            id\n          }\n          id\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b23ead50009a562cb2b880c191983ab9";

export default node;
